/**
 * @generated SignedSource<<91dd257df5cf174c4e8f205c2a13c836>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type fetchTicketNotificationPrefsQuery$variables = {};
export type fetchTicketNotificationPrefsQuery$data = {
  readonly viewer: {
    readonly ticketingNotificationPrefs: {
      readonly emailAssigned: boolean | null;
      readonly emailMentioned: boolean | null;
      readonly emailCustomerReplied: boolean | null;
      readonly emailWatching: boolean | null;
      readonly inAppAssigned: boolean | null;
      readonly inAppMentioned: boolean | null;
      readonly inAppCustomerReplied: boolean | null;
      readonly inAppWatching: boolean | null;
    } | null;
  } | null;
};
export type fetchTicketNotificationPrefsQuery = {
  variables: fetchTicketNotificationPrefsQuery$variables;
  response: fetchTicketNotificationPrefsQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "NotificationPrefs",
  "kind": "LinkedField",
  "name": "ticketingNotificationPrefs",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailAssigned",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailMentioned",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailCustomerReplied",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailWatching",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "inAppAssigned",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "inAppMentioned",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "inAppCustomerReplied",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "inAppWatching",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "fetchTicketNotificationPrefsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "fetchTicketNotificationPrefsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a780fb5265e26e368bf865ea6e7fc983",
    "id": null,
    "metadata": {},
    "name": "fetchTicketNotificationPrefsQuery",
    "operationKind": "query",
    "text": "query fetchTicketNotificationPrefsQuery {\n  viewer {\n    ticketingNotificationPrefs {\n      emailAssigned\n      emailMentioned\n      emailCustomerReplied\n      emailWatching\n      inAppAssigned\n      inAppMentioned\n      inAppCustomerReplied\n      inAppWatching\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d5e2f2769f60350dd70f76f0bc0d9743";

export default node;
